import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AddPharmacyData, PharmacyResponse, PharmacyState, SearchedPharmacyResponse } from "./index.types";

export const initialPharmacyState: PharmacyState = {
  pharmacyList: [],
  pharmacySuccess: false,
  searchedPharmaciesNextPage: null,
  pharmacyIsLoading: false,
  pharmacyAddingIsLoading: false,
  pharmacyAddedSuccess: false,
  pharmacyUpdatingIsLoading: false,
  pharmacyUpdateSuccess: false,
  pharmacyOptions: [],
  searchedPharmaciesList: [],
  searchedPharmaciesSuccess: false,
  searchedPharmaciesOptions: [],
  searchPharmacyInProcess: false,
};

const name = "pharmacy";

export const pharmacySlice = createSlice({
  name,
  initialState: initialPharmacyState,
  reducers: {
    getPharmacy: (state) => {
      state.pharmacyIsLoading = true;
    },
    getPharmacySuccess: (state, action: PayloadAction<PharmacyResponse>) => {
      state.pharmacySuccess = true;
      state.pharmacyIsLoading = false;
      state.pharmacyList = action.payload?.results || [];
      state.pharmacyOptions = (action.payload?.results || []).map(({ pharmacy_name, id, dose_spot_id }) => ({
        value: id,
        label: pharmacy_name,
        doseSpotId: Number(dose_spot_id || 0),
      }));
    },
    getPharmacyFail: (state) => {
      state.pharmacyList = [];
      state.pharmacySuccess = false;
      state.searchedPharmaciesNextPage = null;
      state.pharmacyIsLoading = false;
    },

    //search pharmacy
    getSearchPharmacy: (state) => {
      state.searchPharmacyInProcess = true;
    },
    getSearchPharmacySuccess: (state, action: PayloadAction<SearchedPharmacyResponse>) => {
      state.searchPharmacyInProcess = false;
      state.searchedPharmaciesNextPage = action.payload?.next || null;
      state.searchedPharmaciesList = action.payload?.results || [];
      state.searchedPharmaciesOptions = (action.payload?.results || []).map(({ pharmacy_name, pharmacy_id, address, phone }) => ({
        value: address,
        id: pharmacy_id,
        phone: phone || null,
        label: pharmacy_name,
      }));
    },
    getSearchPharmacyFail: (state) => {
      state.pharmacyList = [];
      state.searchedPharmaciesNextPage = null;
      state.searchPharmacyInProcess = false;
    },

    clearPharmacyData: (state) => {
      state.pharmacyIsLoading = false;
      state.pharmacyList = [];
      state.pharmacyOptions = [];
      state.searchedPharmaciesList = [];
      state.searchedPharmaciesOptions = [];
    },

    //adding pharmacy
    addPharmacy: (state) => {
      state.pharmacyAddingIsLoading = true;
      state.pharmacyAddedSuccess = false;
    },
    addPharmacySuccess: (state) => {
      state.pharmacyAddingIsLoading = false;
      state.pharmacyAddedSuccess = true;
    },
    addPharmacyFail: (state) => {
      state.pharmacyAddingIsLoading = false;
      state.pharmacyAddedSuccess = false;
    },

    //updating pharmacy
    updatePharmacy: (state) => {
      state.pharmacyUpdatingIsLoading = true;
      state.pharmacyUpdateSuccess = false;
    },
    updatePharmacySuccess: (state) => {
      state.pharmacyUpdatingIsLoading = false;
      state.pharmacyUpdateSuccess = true;
    },
    updatePharmacyFail: (state) => {
      state.pharmacyUpdatingIsLoading = false;
      state.pharmacyUpdateSuccess = false;
    },

    ClearPharmacyStates: (state) => {
      state.pharmacyAddingIsLoading = false;
      state.pharmacyAddedSuccess = false;
      state.pharmacyUpdatingIsLoading = false;
      state.pharmacyUpdateSuccess = false;
      state.pharmacyList = [];
      state.pharmacySuccess = false;
    },
    clearSearchPharmacyStates: (state) => {
      state.searchPharmacyInProcess = false;
      state.searchedPharmaciesNextPage = null;
      state.searchedPharmaciesSuccess = false;
      state.searchedPharmaciesList = [];
      state.searchedPharmaciesOptions = [];
    },
  },
});

export const { getPharmacy, clearPharmacyData, ClearPharmacyStates, clearSearchPharmacyStates } = pharmacySlice.actions;

export default pharmacySlice.reducer;

export const getPharmacyList = (patiendId: string | number) => ({
  payload: {
    apiName: name,
    method: "get",
    url: `/api/patients/${patiendId}/pharmacy/`,
  },
  type: "getPharmacy",
});

export const AddPharmacy = (data: AddPharmacyData, patiendId: string | number) => ({
  payload: {
    apiName: name,
    method: "post",
    data,
    url: `/api/patients/${patiendId}/pharmacy/`,
  },
  type: "addPharmacy",
});

export const deletePharmacy = (patiendId: string | number, pharmacyId: string | number) => ({
  payload: {
    apiName: name,
    method: "delete",
    url: `/api/patients/${patiendId}/pharmacy/${pharmacyId}/`,
  },
  type: "addPharmacy", //using single action for both add and delete
});

export const UpdatePharmacyById = () => ({
  payload: {
    apiName: name,
    method: "put",
    url: `/api/pharmacy/`,
  },
  type: "updatePharmacy",
});

export const getSearchPharmacy = (query: string, patientId: string | number, zip_code: string, page: number = 1, signal?: AbortSignal) => ({
  payload: {
    apiName: name,
    method: "get",
    url: `api/patients/${patientId}/pharmacy/search/?zip=${zip_code}&name=${query}&pagenumber=${page}`,
    signal: signal,
  },
  type: "getSearchPharmacy",
});
